import React, { useEffect } from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import MetaDataSearchPageBlockView from './MetaDataSearchPageBlock';
import type { MetaDataSearchPageBlockData } from './MetaDataSearchPageBlock';
import MetaDataSearchPageBlockSchema from './MetaDataSearchPageBlockSchema';
import {
  DEFAULT_VOYAGER_FACET_FIELDS,
  DEFAULT_VOYAGER_FACET_PARAMS,
} from './Services/VoyagerSearchService';

type MetaDataSearchPageBlockEditProps = {
  data?: MetaDataSearchPageBlockData;
  block: string;
  selected?: boolean;
  onChangeBlock: (block: string, data: Record<string, unknown>) => void;
};

const MetaDataSearchPageBlockEdit: React.FC<
  MetaDataSearchPageBlockEditProps
> = (props) => {
  const { data, block, onChangeBlock, selected } = props;

  useEffect(() => {
    if (data?._sidebarFacetConfigInitialized) {
      return;
    }

    onChangeBlock(block, {
      ...data,
      _sidebarFacetConfigInitialized: true,
      sidebarFacetFields:
        data?.sidebarFacetFields ??
        DEFAULT_VOYAGER_FACET_FIELDS.map((item, index) => ({
          '@id': `facet-${index + 1}`,
          field: item.field,
          label: item.label || item.field,
          ...(item.categoryPath?.length
            ? { categoryPath: item.categoryPath.join(' > ') }
            : {}),
          ...(item.useShortLabels ? { useShortLabels: true } : {}),
          ...(typeof item.maxValues === 'number'
            ? { maxValues: item.maxValues }
            : {}),
          ...(item.valueCategories?.length
            ? { valueCategories: JSON.stringify(item.valueCategories, null, 2) }
            : {}),
        })),
      sidebarFacetParams:
        data?.sidebarFacetParams ??
        Object.entries(DEFAULT_VOYAGER_FACET_PARAMS).map(
          ([key, value], index) => ({
            '@id': `facet-param-${index + 1}`,
            key,
            value,
          }),
        ),
    });
  }, [block, data, onChangeBlock]);

  return (
    <>
      <MetaDataSearchPageBlockView {...props} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={MetaDataSearchPageBlockSchema}
          title={MetaDataSearchPageBlockSchema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, {
              ...(data || {}),
              [id]: value,
            });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default MetaDataSearchPageBlockEdit;
